function myFunction() {
    var l, t, n, m, e, a = "",
        i, r;
    if (l = document.getElementById("myInput"), t = l.value.toUpperCase(), r = document.getElementById("myUL"), n = document.querySelectorAll("#model-images .item"), t != "")
        for (e = 0; e < n.length; e++) i = n[e].getElementsByTagName("a")[0], m = i.getElementsByTagName("span")[0], m.innerHTML.toUpperCase().indexOf(t) > -1 && (a += '<li><a href="' + i.getAttribute("href") + '">' + m.innerHTML + "</a></li>");
    r.innerHTML = a;
}